import { formatISO } from 'date-fns';

/**
 * Serializes the date to a string using ISO 8601 format.
 *
 * Intended for use with the `stringify` function from
 * {@link https://www.npmjs.com/package/qs|qs}.
 * @param {Date|Number} date - The date to serialize.
 *
 * @returns {string} The ISO 8601 string representation
 *
 * @example
 * import { stringify } from 'qs';
 *
 * const queryString = stringify(params, {
 *  arrayFormat: 'comma',
 *  serializeDate
 * });
 */
export function serializeDate (date) {
  return formatISO(date);
}
